/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-Master Digital Pharma Async Handling API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { PagedAsyncHandlingOverviewRestDto } from '../models';
import { AsyncHandlingCriteriaDto } from '../models';
/**
 * AsyncHandlingAPIApi - axios parameter creator
 * @export
 */
export const AsyncHandlingAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.ASH.01 Find Async handlings.
         * @param {string} [x_dp_module_code] The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {string} [search_description] Filter the results based on the description.
         * @param {string} [filter_polling_id] Filter the results based on this polling ID.
         * @param {string} [filter_creation_date_from] If provided, filters the results based on the creation date.
         * @param {string} [filter_creation_date_till] If provided, filters the results based on the creation date.
         * @param {string} [filter_qt_type_code] If provided, filters the results based on the type of the associated queued task.
         * @param {string} [filter_qte_status_code] If provided, filters the results based on the type of the associated queued task execution.
         * @param {number} [page] Specifies the page number that is expected of the paged result.
         * @param {number} [page_size] Specifies the maximum number of elements allowed on each page of the paged result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAsyncHandlings: async (x_dp_module_code?: string|null, x_dp_customer_code?: string|null, x_dp_language?: string|null, search_description?: string|null, filter_polling_id?: string|null, filter_creation_date_from?: string|null, filter_creation_date_till?: string|null, filter_qt_type_code?: string|null, filter_qte_status_code?: string|null, page?: number|null, page_size?: number|null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/async_handling/v1/async_handling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (!!search_description || typeof(search_description) === "boolean") {
                localVarQueryParameter['search_description'] = search_description;
            }

            if (!!filter_polling_id || typeof(filter_polling_id) === "boolean") {
                localVarQueryParameter['filter_polling_id'] = filter_polling_id;
            }

            if (!!filter_creation_date_from || typeof(filter_creation_date_from) === "boolean") {
                localVarQueryParameter['filter_creation_date_from'] = (filter_creation_date_from as any instanceof Date) ?
                    (filter_creation_date_from as any).toISOString().substr(0,10) :
                    filter_creation_date_from;
            }

            if (!!filter_creation_date_till || typeof(filter_creation_date_till) === "boolean") {
                localVarQueryParameter['filter_creation_date_till'] = (filter_creation_date_till as any instanceof Date) ?
                    (filter_creation_date_till as any).toISOString().substr(0,10) :
                    filter_creation_date_till;
            }

            if (!!filter_qt_type_code || typeof(filter_qt_type_code) === "boolean") {
                localVarQueryParameter['filter_qt_type_code'] = filter_qt_type_code;
            }

            if (!!filter_qte_status_code || typeof(filter_qte_status_code) === "boolean") {
                localVarQueryParameter['filter_qte_status_code'] = filter_qte_status_code;
            }

            if (!!page || typeof(page) === "boolean") {
                localVarQueryParameter['page'] = page;
            }

            if (!!page_size || typeof(page_size) === "boolean") {
                localVarQueryParameter['page_size'] = page_size;
            }

            if (x_dp_module_code !== undefined && x_dp_module_code !== null) {
                localVarHeaderParameter['x-dp-module-code'] = String(x_dp_module_code);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AsyncHandlingAPIApi - functional programming interface
 * @export
 */
export const AsyncHandlingAPIApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.ASH.01 Find Async handlings.
         * @param {string} [x_dp_module_code] The unique identification of the Digital-Pharma module.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
         * @param {string} [search_description] Filter the results based on the description.
         * @param {string} [filter_polling_id] Filter the results based on this polling ID.
         * @param {string} [filter_creation_date_from] If provided, filters the results based on the creation date.
         * @param {string} [filter_creation_date_till] If provided, filters the results based on the creation date.
         * @param {string} [filter_qt_type_code] If provided, filters the results based on the type of the associated queued task.
         * @param {string} [filter_qte_status_code] If provided, filters the results based on the type of the associated queued task execution.
         * @param {number} [page] Specifies the page number that is expected of the paged result.
         * @param {number} [page_size] Specifies the maximum number of elements allowed on each page of the paged result.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAsyncHandlings(_axios: AxiosInstance, x_dp_module_code?: string|null, x_dp_customer_code?: string|null, x_dp_language?: string|null, search_description?: string|null, filter_polling_id?: string|null, filter_creation_date_from?: string|null, filter_creation_date_till?: string|null, filter_qt_type_code?: string|null, filter_qte_status_code?: string|null, page?: number|null, page_size?: number|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedAsyncHandlingOverviewRestDto>> {
            const localVarAxiosArgs = await AsyncHandlingAPIApiAxiosParamCreator(configuration).findAsyncHandlings(x_dp_module_code, x_dp_customer_code, x_dp_language, search_description, filter_polling_id, filter_creation_date_from, filter_creation_date_till, filter_qt_type_code, filter_qte_status_code, page, page_size, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AsyncHandlingAPIApi - object-oriented interface
 * @export
 * @class AsyncHandlingAPIApi
 * @extends {BaseAPI}
 */
export class AsyncHandlingAPIApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.ASH.01 Find Async handlings.
     * @param {string} [x_dp_module_code] The unique identification of the Digital-Pharma module.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which response is expected. (Fallback to default language for customer if not provided.)
     * @param {string} [search_description] Filter the results based on the description.
     * @param {string} [filter_polling_id] Filter the results based on this polling ID.
     * @param {string} [filter_creation_date_from] If provided, filters the results based on the creation date.
     * @param {string} [filter_creation_date_till] If provided, filters the results based on the creation date.
     * @param {string} [filter_qt_type_code] If provided, filters the results based on the type of the associated queued task.
     * @param {string} [filter_qte_status_code] If provided, filters the results based on the type of the associated queued task execution.
     * @param {number} [page] Specifies the page number that is expected of the paged result.
     * @param {number} [page_size] Specifies the maximum number of elements allowed on each page of the paged result.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncHandlingAPIApi
     */
     private findAsyncHandlings(x_dp_module_code?: string|null, x_dp_customer_code?: string|null, x_dp_language?: string|null, search_description?: string|null, filter_polling_id?: string|null, filter_creation_date_from?: string|null, filter_creation_date_till?: string|null, filter_qt_type_code?: string|null, filter_qte_status_code?: string|null, page?: number|null, page_size?: number|null, options?: any) {
        return AsyncHandlingAPIApiFp(this.configuration).findAsyncHandlings(this.axios, x_dp_module_code, x_dp_customer_code, x_dp_language, search_description, filter_polling_id, filter_creation_date_from, filter_creation_date_till, filter_qt_type_code, filter_qte_status_code, page, page_size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.ASH.01 Find Async handlings.
     * @param {AsyncHandlingCriteriaDto} [dto] The CriteriaRestDto for the api call.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncHandlingAPIApi
     */
    public findAsyncHandlingsByAsyncHandlingCriteriaDto(dto: AsyncHandlingCriteriaDto, options?: any){
        return this.findAsyncHandlings(dto?.x_dp_module_code, dto?.x_dp_customer_code, dto?.x_dp_language, dto?.search_description, dto?.filter_polling_id, dto?.filter_creation_date_from, dto?.filter_creation_date_till, dto?.filter_qt_type_code, dto?.filter_qte_status_code, dto?.page, dto?.page_size, options);
    }
}
